<template>
  <fragment>
    <default-header :h2="$t('passwordReset.title')"></default-header>
    <back-btn></back-btn>
    <div class="innerContent noBottomPadding noSpaceBetween pl-1 pr-1">
      <img class="login-tester" src="@/assets/ebt965p.png" alt="Exide EBT-965P" />
      <div v-if="message.content" class="alert text-center" :class="{ 'alert-success': !message.error, 'alert-danger': message.error }">
        {{message.content}}
      </div>
    </div>
  </fragment>
</template>

<script>
  import DefaultHeader from '@/partials/DefaultHeader';
  import { HTTP } from '../http';
  import BackBtn from '../components/BackBtn';

  export default {
    name: 'Unsubscribe',
    components: {
      DefaultHeader,
      BackBtn
    },
    data() {
      return {
        message: {
          content: null,
          error: false
        }
      };
    },
    beforeMount() {
      let client = this.$route.params.client;
      let uuid = this.$route.params.uuid;

      HTTP.get(`api/unsubscribe/${client}/${uuid}`)
      .then(res => {
        this.message.content = 'Unsubscribed!';
        this.message.error = false;
      }).catch(err => {
        this.message.content = "Can not unsubscribe!";
        this.message.error = true;
      })

    }
  };
</script>

<style>
  .login-tester {
    display: block;
    margin: 0 auto;
    max-width: 60%;
  }

  .desc {
    color: #373a36;
    display: block;
    font-size: 0.7em;
  }
</style>
